// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitTeam2 from "../components/TraitTeam2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";

function Tc2TraitDistribution(Props) {
  var traits = Props.traits;
  var traitTeams = Props.traitTeams;
  var groupCount = Props.groupCount;
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var traits$1 = Belt_Array.slice(Belt_Array.keep(Belt_SortArray.stableSortBy(traits, (function (param, param$1) {
                  return Caml.caml_int_compare(param$1[2], param[2]);
                })), (function (param) {
              return !Sd.isTraitUnique(param[0], set);
            })), 0, 16);
  var places = Belt_Array.map(traits$1, (function (param) {
          return param[3];
        }));
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [places]);
  var minPlace = Caml_splice_call.spliceApply(Math.min, [places]);
  var lowPlace = maxPlace + 0.2;
  var placeRange = lowPlace - minPlace;
  var places$1 = Belt_Array.map(traitTeams, (function (param) {
          return param[2];
        }));
  var maxPlace$1 = Caml_splice_call.spliceApply(Math.max, [places$1]);
  var minPlace$1 = Caml_splice_call.spliceApply(Math.min, [places$1]);
  var lowPlace$1 = maxPlace$1 + 0.2;
  var placeRange$1 = lowPlace$1 - minPlace$1;
  var maxCountPct = Caml_splice_call.spliceApply(Math.max, [Belt_Array.map(traitTeams, (function (param) {
                return param[1];
              }))]) / Global.f(groupCount);
  var countScaleMult = 1 / (
    maxCountPct > 0.2 ? maxCountPct : 0.2
  );
  return React.createElement("div", {
              className: "flex flex-col sm:flex-row sm:justify-around px-2"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "font-medium font-montserrat text-xl mb-2"
                    }, t("Traits")), Belt_Array.map(traits$1, (function (param) {
                        var pl = param[3];
                        var c = param[2];
                        var rank = param[1];
                        var traitId = param[0];
                        return React.createElement("div", {
                                    className: "flex items-center text-xs leading-none mt-1 h-12"
                                  }, React.createElement(TraitTooltip.make, {
                                        trait: traitId,
                                        rank: rank,
                                        children: React.createElement(TraitImage.PlainIcon2.make, {
                                              traitId: traitId,
                                              rank: rank,
                                              size: 36
                                            })
                                      }), React.createElement("div", undefined, React.createElement("div", {
                                            className: "flex items-center"
                                          }, React.createElement("div", {
                                                className: "mx-2 h-3 bg-secondary-9",
                                                style: Global.s({
                                                      width: (Global.f(c) / Global.f(groupCount) * 150).toFixed() + "px"
                                                    })
                                              }), Global.formatPct(undefined, Global.f(c) / Global.f(groupCount)) + "%"), React.createElement("div", {
                                            className: "flex items-center mt-1"
                                          }, React.createElement("div", {
                                                className: "mx-2 h-3 bg-primary-11",
                                                style: Global.s({
                                                      width: ((lowPlace - pl) / placeRange * 150).toFixed() + "px"
                                                    })
                                              }), Global.toFixed(undefined, pl))));
                      }))), React.createElement("div", {
                  className: "pt-8 sm:pt-0 sm:pl-12"
                }, React.createElement("div", {
                      className: "font-medium font-montserrat text-xl mb-2"
                    }, t("Full Traits")), Belt_Array.map(Belt_Array.slice(traitTeams, 0, 16), (function (param) {
                        var pl = param[2];
                        var c = param[1];
                        return React.createElement("div", {
                                    className: "flex items-center text-xs leading-none mt-1 h-12"
                                  }, React.createElement("div", {
                                        className: "flex justify-end w-[100px]"
                                      }, React.createElement(TraitTeam2.make, {
                                            traits: Belt_Array.map(param[0], (function (param) {
                                                    return [
                                                            param[0],
                                                            param[1]
                                                          ];
                                                  }))
                                          })), React.createElement("div", undefined, React.createElement("div", {
                                            className: "flex items-center"
                                          }, React.createElement("div", {
                                                className: "mx-2 h-3 bg-secondary-9",
                                                style: Global.s({
                                                      width: (c * countScaleMult / Global.f(groupCount) * 175).toFixed() + "px"
                                                    })
                                              }), Global.formatPct(undefined, c / Global.f(groupCount)) + "%"), React.createElement("div", {
                                            className: "flex items-center mt-1"
                                          }, React.createElement("div", {
                                                className: "mx-2 h-3 bg-primary-11",
                                                style: Global.s({
                                                      width: ((lowPlace$1 - pl) / placeRange$1 * 175).toFixed() + "px"
                                                    })
                                              }), Global.toFixed(undefined, pl))));
                      }))));
}

var make = Tc2TraitDistribution;

export {
  make ,
  
}
/* Sd Not a pure module */
